import { useIntl, FormattedMessage } from "react-intl";
import { IoSaveOutline, IoCloseCircleOutline } from "react-icons/io5";
import FormButton from "../../../../components/FormButton";
import {
  ActionsContainer,
  ButtonsContainer,
  CancelButton,
} from "../styles";

/**
 * Componente para os botões de ação do formulário
 * Mantém exatamente a mesma funcionalidade dos botões originais
 */
const FormActions = ({
  loading,
  onCancel,
  onSubmit,
}) => {
  const intl = useIntl();

  return (
    <ActionsContainer>
      <ButtonsContainer>
        <CancelButton
          data-test="cancel-button"
          type="button"
          onClick={onCancel}
          disabled={loading}
          height="40px"
        >
          <IoCloseCircleOutline size={22} />
          <FormattedMessage id="cancel" />
        </CancelButton>

        <FormButton
          data-test="save-button"
          type="submit"
          loading={loading}
          height="40px"
          disabled={loading}
          style={{ minWidth: "150px" }}
          onClick={onSubmit}
        >
          <IoSaveOutline size={22} />
          <FormattedMessage id="save" />
        </FormButton>
      </ButtonsContainer>
    </ActionsContainer>
  );
};

export default FormActions;